module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group film_something_now_enabled"
  }), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "10px"
    }
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t("settings.ftp")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Host",
      "required": ""
    },
    model: {
      value: (_vm.settings.ftp.host),
      callback: function($$v) {
        _vm.$set(_vm.settings.ftp, "host", $$v)
      },
      expression: "settings.ftp.host"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Path",
      "required": ""
    },
    model: {
      value: (_vm.settings.ftp.path),
      callback: function($$v) {
        _vm.$set(_vm.settings.ftp, "path", $$v)
      },
      expression: "settings.ftp.path"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "User",
      "required": ""
    },
    model: {
      value: (_vm.settings.ftp.user),
      callback: function($$v) {
        _vm.$set(_vm.settings.ftp, "user", $$v)
      },
      expression: "settings.ftp.user"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "append-icon": _vm.showPwd ? 'visibility' : 'visibility_off',
      "type": _vm.showPwd ? 'text' : 'password',
      "label": "Password",
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.showPwd = !_vm.showPwd
      }
    },
    model: {
      value: (_vm.settings.ftp.password),
      callback: function($$v) {
        _vm.$set(_vm.settings.ftp, "password", $$v)
      },
      expression: "settings.ftp.password"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("settings.push_localization")))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("settings.push_thank_you")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('settings.push_thank_you'),
        maxlength: 100,
        name: 'push_thank_you',
        required: true,
        rows: 1,
        autofocus: false,
      }
    },
    model: {
      value: (_vm.settings.localized_thank_you),
      callback: function($$v) {
        _vm.$set(_vm.settings, "localized_thank_you", $$v)
      },
      expression: "settings.localized_thank_you"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("settings.push_marker_request")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('settings.push_marker_request'),
        maxlength: 100,
        name: 'push_marker_request',
        required: true,
        rows: 1,
        autofocus: false,
      }
    },
    model: {
      value: (_vm.settings.localized_marker_request),
      callback: function($$v) {
        _vm.$set(_vm.settings, "localized_marker_request", $$v)
      },
      expression: "settings.localized_marker_request"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "locale-selection"
  }, _vm._l((_vm.locales), function(l) {
    return _c('a', {
      key: l,
      class: {
        'selected': l === _vm.currentEditLocale
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.currentEditLocale = l
        }
      }
    }, [(l == "en") ? _c('span', [_vm._v(_vm._s(l) + " (default)")]) : _c('span', [_vm._v(_vm._s(l))])])
  }), 0), _vm._v(" "), _c('br')]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("settings.choose_export")))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Export type",
      "items": _vm.exportTypes,
      "single-line": "",
      "attach": ""
    },
    model: {
      value: (_vm.settings.export_type),
      callback: function($$v) {
        _vm.$set(_vm.settings, "export_type", $$v)
      },
      expression: "settings.export_type"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("settings.choose_export_individual_format")))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Export individual format",
      "items": _vm.exportIndividualFormats,
      "item-value": "value",
      "item-text": "text",
      "single-line": "",
      "attach": ""
    },
    model: {
      value: (_vm.settings.export_individual_format),
      callback: function($$v) {
        _vm.$set(_vm.settings, "export_individual_format", $$v)
      },
      expression: "settings.export_individual_format"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('v-checkbox', {
    attrs: {
      "label": "Should the 'Film something now' button be enabled?"
    },
    model: {
      value: (_vm.settings.film_something_now_enabled),
      callback: function($$v) {
        _vm.$set(_vm.settings, "film_something_now_enabled", $$v)
      },
      expression: "settings.film_something_now_enabled"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "10px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "iOS app version"
    },
    model: {
      value: (_vm.settings.ios_app_version),
      callback: function($$v) {
        _vm.$set(_vm.settings, "ios_app_version", $$v)
      },
      expression: "settings.ios_app_version"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "10px"
    }
  }, [_c('legend', [_vm._v("Video quality")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "label": "WiFi",
      "items": _vm.videoQualityVariants,
      "attach": ""
    },
    model: {
      value: (_vm.settings.video_quality.wifi),
      callback: function($$v) {
        _vm.$set(_vm.settings.video_quality, "wifi", $$v)
      },
      expression: "settings.video_quality.wifi"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "label": "4G",
      "items": _vm.videoQualityVariants,
      "attach": ""
    },
    model: {
      value: (_vm.settings.video_quality.mobile_4g),
      callback: function($$v) {
        _vm.$set(_vm.settings.video_quality, "mobile_4g", $$v)
      },
      expression: "settings.video_quality.mobile_4g"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "label": "3G",
      "items": _vm.videoQualityVariants,
      "attach": ""
    },
    model: {
      value: (_vm.settings.video_quality.mobile_3g),
      callback: function($$v) {
        _vm.$set(_vm.settings.video_quality, "mobile_3g", $$v)
      },
      expression: "settings.video_quality.mobile_3g"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-full-width",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65cbd542"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ConsumerSettings.vue
// module id = 1049
// module chunks = 1